<template>
  <aha-modal
    :title="$i18nPresenter.t('Add slide to PowerPoint')"
    @hide="hideModal"
  >
    <div
      class="tab-content"
      v-if="isShowOldPPT"
    >
      <div class="text-center">
        <img src="@/assets/images/ppt/ppt-intro.svg" class="m-auto">
      </div>
      <div
        v-if="
          type === 'imageChoice' || type === 'multipleChoice'
            || type === 'wordCloud' || type === 'question' ||
            type === 'leaderboard' || type === 'spinnerWheel' ||
            (type === 'pickAnswer' && slideType === null) ||
            (type === 'pickAnswer' && slideType === 'imageChoice')
        "
      >
        <div class="text-left mt-4">
          <div class="my-4 mb-1 flex items-center">
            <span class="step-number"><b>1</b></span>
            <span class="step-content">
              <span v-html="$i18nPresenter.t('inPPTDownloadThe')"></span>
              <strong>
                <a target="_blank" @click="trackingClickDA"> {{ $i18nPresenter.t('AhaSlides add-in') }}</a>
                <aha-icon
                  name="open-new-window"
                  class="text-base-80 mb-1"
                  width="20"
                  height="20"
                />
              </strong>
            </span>
          </div>
          <div class="my-4">
            <span class="step-number"><b>2</b></span>
            <span class="step-content" v-html="$i18nPresenter.t('copyTheSlideLinkBelow')">
            </span>
          </div>
          <div class="mt-4 flex items-center">
            <span class="step-number"><b>3</b></span>
            <span class="step-content" v-html="$i18nPresenter.t('pasteTheLinkOnAhaAddIn')">
            </span>
          </div>
        </div>
        <div class="text-right mt-10">
          <div class="tutorial-link inline-flex float-left mt-2">
            <a
              :href="youtubeLink"
              class="float-left text-base-80 contents"
              target="_blank"
              @click="trackingClickTutorial"
            >
              <img
                class="mr-1"
                :src="require('@/assets/images/icon/play.svg')"
              >
              <b>{{ $i18nPresenter.t('Tutorial') }}</b>
            </a>
          </div>
          <aha-button class="px-6" @click="copySlideUrl">
            <i class="fas fa-link mr-1" style="font-size:12px;"></i>{{ $i18nPresenter.t('Copy link') }}
          </aha-button>
          <aha-link variant="base" class="ml-2 font-bold" @click="doneModal">
            {{ $i18nPresenter.t('Done') }}
          </aha-link>
        </div>
      </div>
      <div v-else class="not-support-ppt">
        <p>{{ $i18nPresenter.t('The Beta version is only available for the slide types below') }}:</p>
        <ul>
          <li>Pick Answer</li>
          <li>Pick Image</li>
          <li>Spinner Wheel</li>
          <li>Leaderboard</li>
          <li>Poll</li>
          <li>Word Cloud</li>
          <li>Q&A</li>
        </ul>

        <div class="text-right mb-2">
          <aha-link
            @click="isShowOldPPT = false"
            class="font-bold"
            variant="base"
          >
            {{ $i18nPresenter.t('Back') }}
          </aha-link>
          <aha-button class="ml-4" @click="hideModal">
            {{ $i18nPresenter.t('Got It') }}
          </aha-button>
        </div>
      </div>
    </div>

    <div class="tab-content" v-if="!isShowOldPPT">
      <div class="text-left">
        <img src="@/assets/images/ppt/ppt-ad.svg" class="m-auto">
        <ul class="mt-6">
          <li class="mt-1">
            {{ $i18nPresenter.t('Seamlessly create, edit and present AhaSlides directly in your PowerPoint.') }}
          </li>
          <li>
            {{ $i18nPresenter.t('Compatible with PowerPoint version 2019 and above.') }}
          </li>
        </ul>
        <a
          target="_blank"
          href="https://help.ahaslides.com/portal/en/kb/articles/using-powerpoint-s-ahaslides-add-in"
          class="text-primary-90 mt-4 block"
        >{{ $i18nPresenter.t('Learn more') }}
          <aha-icon
            name="open-new-window"
            class="mb-1"
            width="20"
            height="20"
          />
        </a>
      </div>
    </div>
    <div class="text-right mb-2" v-if="!isShowOldPPT">
      <aha-link
        @click="hideModal"
        class="font-bold"
      >
        {{ $i18nPresenter.t('Later') }}
      </aha-link>
      <aha-button class="ml-4" @click="trackingClickDA">
        {{ $i18nPresenter.t('Download Add-in') }}
      </aha-button>
    </div>
  </aha-modal>
</template>

<script>
import Utils from '@/util'
import config from '@/config'
import constants from '@/constant'

const { eventCategories } = constants
const appSourceLink = 'https://appsource.microsoft.com/en-us/product/office/WA200004824'
const youtubeLink = 'https://www.youtube.com/watch?v=pQfgGpkqdLQ'
export default {
  props: {
    slideType: {
      default: '',
      type: String,
    },
    type: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      youtubeLink,
      appSourceLink,
      isShowOldPPT: false,
    }
  },
  mounted() {
  },
  methods: {
    openOlderVersion() {
      this.isShowOldPPT = true
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Open old version')
    },
    copySlideUrl(e) {
      e.stopPropagation()
      const copiedLink = `${config.powerpointDomain}/slide/${this.$store.state.slideActive.id}`
      navigator.clipboard.writeText(copiedLink)
      Utils.showToastSuccess(this.$i18nPresenter.t('Link copied!'))
      const slideName = Utils.getCorrectSlideTypeName(this.type, this.slideType)
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Copy link', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    trackingClickTutorial() {
      const slideName = Utils.getCorrectSlideTypeName(this.type, this.slideType)
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Play tutorial', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    // eslint-disable-next-line sonarjs/no-identical-functions
    trackingClickDA() {
      window.open(appSourceLink, '_blank')
      const slideName = Utils.getCorrectSlideTypeName(this.type, this.slideType)
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Open AhaSlides add-in download page', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    hideModal() {
      this.$emit('hide')
    },
    doneModal() {
      this.$emit('done')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.tab-content {
  @apply pb-4;
  @apply relative text-center;
}
.step-number {
  width: 28px;
  height: 28px;
  background-color: #DDECFF;
  border-radius: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  b {
    color: #4F9BF3;
  }
}
.tab-content {
  strong {
    a {
      color: #348EF6;
    }
    svg {
      color: #348EF6;
    }
  }

  // a {
  //   color: #348EF6;
  //   &:hover {
  //     @apply text-primary-100
  //   }
  // }
}
.step-content {
  @apply ml-2;
  width: 20rem;
}
a {
  cursor: pointer;
}
.tutorial-link {
  &:hover {
    img {
      filter: invert(47%) sepia(29%)
      saturate(4907%) hue-rotate(195deg) brightness(102%) contrast(93%);
    }
  }
}
.warning-box {
  background-color: #F2F7FF;
  padding: 8px;
  margin-top: 20px;
  border-radius: 4px;
  font-size: 12px;

  i {
    color: #2F80ED;
  }
}
ul {
  list-style: unset;
  padding-left: 16px;
}

.not-support-ppt {
  text-align: left;
}
</style>
